import { render, staticRenderFns } from "./DsfrPagination.vue?vue&type=template&id=1a123c7c&scoped=true&"
import script from "./DsfrPagination.vue?vue&type=script&lang=js&"
export * from "./DsfrPagination.vue?vue&type=script&lang=js&"
import style0 from "./DsfrPagination.vue?vue&type=style&index=0&id=1a123c7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a123c7c",
  null
  
)

export default component.exports